var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberOneSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122.88,
    height: 122.88,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "one-number-round") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#0A4997",
    id: "svg_1",
    fillRule: "evenodd",
    d: "m61.44,0a61.46,61.46 0 1 1 -43.44,18a61.21,61.21 0 0 1 43.44,-18z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FAFAFA",
    id: "svg_2",
    points: "67.7699966430664,38.59000015258789 67.7699966430664,84.27999877929688 55.369998931884766,84.27999877929688 55.369998931884766,50.02000045776367 55.099998474121094,50.02000045776367 45.11000061035156,56 45.11000061035156,45.470001220703125 56.349998474121094,38.59000015258789 67.7699966430664,38.59000015258789 67.7699966430664,38.59000015258789 ",
    className: "cls-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOneSolid);
export default __webpack_public_path__ + "static/media/number-one-solid.edda5a854697861c9dec27dcc27c953b.svg";
export { ForwardRef as ReactComponent };